import { TableColumnType } from 'antd'
import moment from 'moment'
import React from 'react'
import { getMaterialsCategoryName } from '../../models/commodity'
import { DateTimeFormat } from '../../models/datetime'
import { Dimen } from '../../models/dimen'
import { getSupplierCategory } from '../../models/supplierCategory'

// 西药列表
export const MedicalColumns = (
  onclick: (id: number) => void,
  startIndex: number
): TableColumnType<any>[] => {
  return [
    {
      title: '序号',
      align: 'center',
      width: Dimen.Num,
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '目录名称',
      align: 'center',
      dataIndex: 'regName',
      width: '8rem',
      sorter: (a, b) => {
        return a.regName.length - b.regName.length
      },
    },
    {
      title: '中心编码',
      align: 'center',
      dataIndex: 'medListCodg',
      width: Dimen.Code,
    },
    {
      title: '剂型',
      align: 'center',
      dataIndex: 'drugDosform',
      width: Dimen.Category,
    },
    {
      title: '规格',
      align: 'center',
      dataIndex: 'drugSpec',
      width: Dimen.Category,
    },
    {
      title: '单位',
      align: 'center',
      dataIndex: 'minPacunt',
      width: Dimen.Coding,
    },
    {
      title: '厂家',
      align: 'center',
      dataIndex: 'prodentpName',
    },
  ]
}

// 中药列表
export const CMedicalColumns = (
  onclick: (id: number) => void,
  startIndex: number
): TableColumnType<any>[] => {
  return [
    {
      title: '序号',
      align: 'center',
      width: Dimen.Num,
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '中药目录名称',
      align: 'center',
      dataIndex: 'tcmherbName',
      width: '8rem',
      sorter: (a, b) => {
        return a.tcmherbName.length - b.tcmherbName.length
      },
    },
    {
      title: '中心编码',
      align: 'center',
      dataIndex: 'medListCodg',
      width: '8rem',
    },
    {
      title: '用法',
      align: 'center',
      dataIndex: 'cnvlUsed',
      width: Dimen.Category,
      ellipsis: true,
    },
    {
      title: '功能主治',
      align: 'center',
      dataIndex: 'efccAtd',
      key: 'efccAtd',
      width: Dimen.Category,
      ellipsis: true,
    },
  ]
}

// 诊疗列表
export const DiagnosisColumns = (
  onclick: (id: number) => void,
  startIndex: number
): TableColumnType<any>[] => {
  return [
    {
      title: '序号',
      align: 'center',
      width: Dimen.Num,
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '诊疗目录名称',
      align: 'center',
      dataIndex: 'servitemName',
      width: '8rem',
      sorter: (a, b) => {
        return a.servitemName.length - b.servitemName.length
      },
    },
    {
      title: '中心编码',
      align: 'center',
      dataIndex: 'medListCodg',
      width: '8rem',
    },
    {
      title: '单位',
      align: 'center',
      dataIndex: 'prcunt',
      width: Dimen.Category,
    },
    {
      title: '项目说明',
      align: 'center',
      dataIndex: 'trtItemDscr',
      key: 'trtItemDscr',
      width: Dimen.Category,
      ellipsis: true,
    },
  ]
}

// 材料列表
export const MaterialsColumns = (
  onclick: (id: number) => void,
  startIndex: number
): TableColumnType<any>[] => {
  return [
    {
      title: '序号',
      align: 'center',
      width: Dimen.Num,
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '材料目录名称',
      align: 'center',
      dataIndex: 'hiGenname',
      width: '8rem',
      sorter: (a, b) => {
        return a.hiGenname.length - b.hiGenname.length
      },
    },
    {
      title: '中心编码',
      align: 'center',
      dataIndex: 'medListCodg',
      width: '8rem',
    },
    {
      title: '规格',
      align: 'center',
      dataIndex: 'spec',
      width: Dimen.Category,
    },
    {
      title: '备案公司',
      align: 'center',
      dataIndex: 'regerName',
      key: 'regerName',
      width: Dimen.Category,
      ellipsis: true,
    },
    {
      title: '结构及组成',
      align: 'center',
      dataIndex: 'struComp',
      key: 'struComp',
      width: Dimen.Category,
      ellipsis: true,
    },
  ]
}

// 限价列表
export const LimitPriceColumns = (
  onclick: (id: number) => void,
  startIndex: number
): TableColumnType<any>[] => {
  return [
    {
      title: '序号',
      align: 'center',
      width: Dimen.Num,
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    // {
    //   title: '材料目录名称',
    //   align: 'center',
    //   dataIndex: 'hiGenname',
    //   width: '8rem',
    //   sorter: (a, b) => {
    //     return a.hiGenname.length - b.hiGenname.length
    //   },
    // },
    {
      title: '中心编码',
      align: 'center',
      dataIndex: 'hilistCode',
      width: '8rem',
    },
    {
      title: '限价金额',
      align: 'center',
      dataIndex: 'hilistPricUplmtAmt',
      width: Dimen.Category,
      render: (_, t) => {
        return Number(t.hilistPricUplmtAmt).toFixed(2)
      },
    },
    {
      title: '开始日期',
      align: 'center',
      dataIndex: 'begndate',
      key: 'begndate',
      width: Dimen.Category,
      ellipsis: true,
      render: (_, t) => {
        return moment(t.begndate).format(DateTimeFormat)
      },
    },
    {
      title: '结束日期',
      align: 'center',
      dataIndex: 'enddate',
      key: 'enddate',
      width: Dimen.Category,
      ellipsis: true,
      render: (_, t) => {
        return moment(t.enddate).format(DateTimeFormat)
      },
    },
  ]
}
